export default __webpack_public_path__ + "/img/dep02.ca6b5819.jpg";